import { Outlet, useLocation } from "react-router-dom";
import Info from "../components/common/info";
import BuyGoodsDisclaimer from "../components/common/bg-disclaimer";
import { useEffect, useRef, useState } from "react";

const Layout = () => {
    const [showModal, setShowModal] = useState(false);
    const modalShownCount = useRef(0);
    const location = useLocation();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const npValue = searchParams.get('np');

        if (npValue === 'y') return;
        const handleMouseOut = (e: MouseEvent) => {
            if (e.clientY < 0 && modalShownCount.current < 2) {
                modalShownCount.current += 1;
                setShowModal(true);
            }
        };

        window.addEventListener('mouseout', handleMouseOut);
        return () => window.removeEventListener('mouseout', handleMouseOut);
    }, [location.search]);

    return (
        <>
            <Outlet />
            <Info />
            <BuyGoodsDisclaimer />
            {showModal && (
                <section id="go-back-modal">
                    <div className="gg-modal">
                        <div className="container-fluid">
                            <div className="row align-items-center justify-content-center text-center">
                                <div className="col-md-6 col-10 gg-modal-content">
                                    <div className="row align-items-center justify-content-center pt-3">
                                        <div className="col-11 gg-bg-solid-blue gg-border-radius text-white">
                                            <h2 className="text-uppercase">Wait! Don't go away!</h2>
                                        </div>
                                    </div>
                                    <div className="row align-items-center justify-content-center pt-3">
                                        <div className="col-11">
                                            <p className="fs-6">
                                                There’s something on this page most people never hear.<br />
                                                It’s not in the news. It’s not from your doctor.<br />
                                                But it could change everything for anyone dealing with blood sugar struggles and Type 2.
                                            </p>
                                            <p className="fs-6">
                                                If you’re here, there’s a reason. <br />
                                                Stay a few more seconds. <br />
                                                What’s revealed next might be the one thing you were never told…<br />
                                                And always needed to know.<br />

                                            </p>
                                            <p className="fs-6">
                                                Click <b>“Stay on Page”</b> to find out the information that’s been hidden from the public for decades because it threatens a $48 billion industry.
                                            </p>
                                        </div>
                                        <button onClick={() => setShowModal(false)} className="btn gg-button-buy-green gg-buy-card-button gg-bigger-button mb-3 fs-5 fw-bold">Stay on Page</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
            )}
        </>
    );
};

export default Layout;